module.exports = {"id":"146530","name":"Dani Alves","rating":"83","photo":"./data/images/photos/3/146530.png","club":{"name":"Paris","logo":"./data/images/clubs/Paris.png"},"positions":["DD"],"photoFolderIndex":3}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DaniAlves0.json
// module id = 909
// module chunks = 0